import classNames from "classnames";
import PropTypes from "prop-types";

import style from "./Loader.module.scss";

const Loader = ({ isAppMode = false, constrainedHeight = false }) => (
    <div className={classNames(style.loader, { [style.appMode]: isAppMode, [style.constrainedHeight]: constrainedHeight })} aria-label="Loading, please wait" />
);

Loader.propTypes = {
    isAppMode: PropTypes.bool,
};

export default Loader;